import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { LiraAdvContainer } from '@sbt-web/adv';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
export const resetLoaded = () => {
  loaded = false;
};
let loaded = false;
export const LiraLazySlotReplyBox = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp3, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LiraAdvContainer idForAd={LiraContainerIds.adView.replyBox} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp() {
  loaded = false;
}
function _temp2() {
  window.liraSdk.fetchLazyLoadAd([LiraContainerIds.adView.replyBox]).then(_temp);
}
function _temp3() {
  if (loaded) {
    return;
  }
  loaded = true;
  window.liraSDKQueue?.push(_temp2);
}